<template>
  <div class="pipe-extraction bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-row :gutter="10" class="pr-5px">
      <el-col :span="12">
        <el-select
          v-model="searchData.deviceName"
          size="small"
          class="ml-5px"
          ref="fatherNode"
          popper-class="visualization-select-popper"
          placeholder="请选择装置"
          filterable
        >
          <el-input
            placeholder="此处输入关键词搜索查询"
            prefix-icon="el-icon-search"
            v-model="treeFilterKey"
            size="mini"
            clearable
          ></el-input>
          <el-option
            hidden
            key="id"
            :label="searchData.deviceName"
            :value="searchData.deviceName"
          ></el-option>
          <el-tree
            v-loading="deviceTreeLoading"
            ref="smallTreeDom"
            :data="treeData"
            empty-text="暂无数据"
            highlight-current
            :props="defaultTreeProps"
            :expand-on-click-node="false"
            :default-expand-all="false"
            :filter-node-method="filterTreeNode"
            @node-click="treeSelect"
            class="device-tree text-14px"
          >
          </el-tree>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-input
          size="small"
          v-model="searchData.tagCode"
          placeholder="请输入管道编码"
          clearable
          class="ml-5px"
        ></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="pr-5px mt-10px">
      <el-col :span="12">
        <el-select
          size="small"
          class="ml-5px"
          popper-class="visualization-select-popper"
          v-model="searchData.medium"
          placeholder="请选择介质"
          filterable
          clearable
        >
          <el-option
            v-for="item in mediumList"
            :label="item.value"
            :value="item.key"
            :key="item.key"
          />
        </el-select>
      </el-col>
      <el-col :span="12" class="search-wrap h-36px leading-36px">
        <el-button @click="searchHandler" size="small" type="primary" class="ml-5px"
          >搜索</el-button
        >
        <el-button
          @click="changeAllStatus"
          :disabled="allFlowDisabled"
          size="small"
          type="primary"
          class="ml-5px"
          >抽离</el-button
        >
      </el-col>
    </el-row>
    <div class="flex items-center">
      <span class="pr-20px text-[#fff] text-14px">透明度</span>
      <el-slider
        class="flex-1"
        v-model="transparency"
        @change="transChange"
        :format-tooltip="tooltipFormat"
      ></el-slider>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      height="calc(100% - 158px)"
      :row-key="(row) => row.tagId"
      class="markerTable"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      @row-click="moveToPipe"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="deviceName" label="装置名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tagName" label="管道名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="medium" label="介质">
        <template slot-scope="{ row }">
          <span>{{ getMediumName(row.medium) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { isEmpty, findIndex, filter, map, forEach } from 'lodash'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { ModelApi } from '@wiz-api/material-management'

const modelApi = new ModelApi()
const threeDimensionsApi = new ThreeDimensionsApi()
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
  },
  data() {
    return {
      deviceTreeLoading: false,
      allFlowDisabled: true,
      allFlowStatus: false, // 批量流向动画展示
      treeFilterKey: null,
      curRootItem: null, // 当前根节点
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      transparency: (60 / 255) * 100,
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      searchData: {
        deviceName: null,
        tagCode: null,
        medium: null,
      },
      tableData: [],
      treeData: [], // 装置treeData
      deviceList: [], // 装置列
      mediumList: [], // 介质列
      currentShowPipes: [], // 当前已经创建的动画
      currentSelectedPipe: [], // 表格多选
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.modelSetting ||
        {}
      )
    },
  },
  watch: {
    treeFilterKey(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
  async created() {
    // 装置
    this.getDeviceList()
    // 介质
    this.getMediumList()
  },
  async beforeDestroy() {
    // 获取根节点
    const rootInfo = await this.player.Native.ModelTree.getRootItems()
    if (rootInfo?.length && rootInfo[0].item) {
      // 恢复模型状态
      await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
    }
  },
  methods: {
    // 通过key获取介质名称
    getMediumName(key) {
      const index = _.findIndex(this.mediumList, ['key', key])
      if (index > -1) {
        return this.mediumList[index].value
      }
      return ''
    },
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 透明度修改
    async transChange(val) {
      if (this.currentShowPipes.length) {
        this.$emit('loadingSwitch', { bol: true, title: '透明度调整中' })
        try {
          // 获取根节点
          const rootInfo = await this.player.Native.ModelTree.getRootItems()
          if (rootInfo?.length && rootInfo[0].item) {
            // 恢复模型状态
            await this.player.Native.ModelTree.setItemAlpha(
              rootInfo[0].item,
              Math.round((this.transparency / 100) * 255)
            )
          }
          const params = _.map(this.currentShowPipes, (item) => {
            return {
              item: item.item,
              alpha: 255,
            }
          })
          this.player.Native.ModelTree.batchSetItemAlpha(params)
          this.$emit('loadingSwitch', { bol: false, title: '透明度调整中' })
        } catch (error) {
          console.error('---> error', error)
          this.$emit('loadingSwitch', { bol: false, title: '透明度调整中' })
        }
      }
    },
    // 滑块format
    tooltipFormat(val) {
      return (val / 100).toFixed(1)
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      this.searchData.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.resetData()
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 重置数据
    async resetData() {
      this.currentShowPipes = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = [] // 清空表单
    },
    // 监听模型切换加载完成操作
    checkModelLoadEnd(value, handle, name) {
      this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      // this.initDevice()
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取模型详情信息
    async getModelDetail() {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        if (modelInfo?.fileInfoId) {
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    // 全量修改抽离状态
    async changeAllStatus() {
      this.allFlowStatus = !this.allFlowStatus
      if (this.allFlowStatus) {
        if (_.isEmpty(this.currentShowPipes)) {
          await this.initDevice()
        }
        try {
          this.player.Native.Camera.moveToCode(this.currentSelectedPipe[0].tagCode, 2)
          const needOpenPipes = filter(this.currentSelectedPipe, ['status', false])
          if (needOpenPipes?.length) {
            const itemAsync = []
            for (let k = 0; k < needOpenPipes.length; k += 1) {
              // eslint-disable-next-line no-await-in-loop
              const itemInfo = await this.player.Native.ModelTree.findItemByCode(
                needOpenPipes[k].tagCode,
                this.curRootItem
              )
              itemAsync.push(itemInfo)
            }
            await Promise.all(itemAsync)
            const itemList = map(itemAsync, (it) => {
              return {
                item: it.item,
                alpha: 255,
              }
            })
            await this.player.Native.ModelTree.batchSetItemAlpha(itemList)
            for (let j = 0; j < needOpenPipes.length; j += 1) {
              this.currentShowPipes.push({
                code: needOpenPipes[j].tagCode,
                item: itemAsync[j].item,
              })
            }
            // 同步更新对应操作列开关状态
            const codeList = map(needOpenPipes, 'tagCode')
            forEach(this.tableData, (item) => {
              if (codeList.includes(item.tagCode)) {
                item.status = true
              }
            })
          }
        } catch (error) {
          console.error(`管线抽离出错了  ${error}`)
        }
      } else {
        const needClosePipes = filter(this.currentSelectedPipe, ['status', true])
        const needCloseItem = []
        for (let i = 0; i < needClosePipes.length; i += 1) {
          const showIndex = findIndex(this.currentShowPipes, ['code', needClosePipes[i].tagCode])
          if (showIndex > -1) {
            needCloseItem.push({
              item: this.currentShowPipes[showIndex].item,
              alpha: 60,
            })
          }
        }
        const needCloseCodes = map(needClosePipes, 'tagCode')
        await this.player.Native.ModelTree.batchSetItemAlpha(needCloseItem)
        this.currentShowPipes = filter(this.currentShowPipes, (item) => {
          return !needCloseCodes.includes(item.code)
        })
        if (_.isEmpty(this.currentShowPipes)) {
          this.resetDevice()
        }
        // 更新表中开关状态
        forEach(this.tableData, (item) => {
          if (needCloseCodes.includes(item.tagCode)) {
            item.status = false
          }
        })
      }
    },
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.searchData.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
          } else {
            this.searchData.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
          }
          this.searchData = Object.assign(this.searchData, {
            tagCode: null,
            medium: null,
          })
          // this.initDevice() // 初始化装置半透明
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 初始化装置状态，
    async initDevice() {
      this.$emit('loadingSwitch', { bol: true, title: '正在初始化装置' })
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        this.curRootItem = rootInfo[0].item
        await this.player.Native.ModelTree.setItemAlpha(
          rootInfo[0].item,
          Math.round((this.transparency / 100) * 255)
        )
      }
      this.$emit('loadingSwitch', { bol: false, title: '正在初始化装置' })
    },
    // 获取材质列表
    async getMediumList() {
      const [err, res] = await threeDimensionsApi.getSysDatat({
        parentKey: 'Medium',
      })
      if (!err && res?.code && res.code === '200' && res.data) {
        this.mediumList = res.data
      }
    },
    // 获取管线表数据
    async getTableData() {
      // currentDeviceId
      const [err, res] = await threeDimensionsApi.getDeviceRelationPipeLineList({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          deviceId: this.currentDeviceId,
          tagCode: this.searchData.tagCode ? `%${this.searchData.tagCode}%` : null,
          medium: this.searchData.medium,
        },
      })
      if (!err && res?.code && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
      forEach(this.tableData, (item) => {
        const index = findIndex(this.currentShowPipes, ['code', item.tagCode])
        if (index > -1) {
          this.$set(item, 'status', true)
        } else {
          this.$set(item, 'status', false)
        }
      })
    },
    // 单个管线状态修改
    async changeStatus(row) {
      if (row.status) {
        if (_.isEmpty(this.currentShowPipes)) {
          await this.initDevice()
        }
        try {
          this.player.Native.Camera.moveToCode(row.tagCode, 2)
          const itemInfo = await this.player.Native.ModelTree.findItemByCode(
            row.tagCode,
            this.curRootItem
          )
          if (itemInfo?.item) {
            this.player.Native.ModelTree.setItemAlpha(itemInfo.item, 255)
            this.currentShowPipes.push({
              code: row.tagCode,
              item: itemInfo.item,
            })
          }
          this.resetSwitchStatus()
        } catch (error) {
          console.error(`打开管线抽离出错了  ${error}`)
        }
      } else {
        const index = findIndex(this.currentShowPipes, ['code', row.tagCode])
        if (index > -1) {
          await this.player.Native.ModelTree.setItemAlpha(
            this.currentShowPipes[index].item,
            Math.round((this.transparency / 100) * 255)
          )
          this.currentShowPipes.splice(index, 1)
        }
        if (_.isEmpty(this.currentShowPipes)) {
          this.resetDevice()
        }
        this.resetSwitchStatus()
      }
    },
    // 重置装置透明度
    async resetDevice() {
      this.$emit('loadingSwitch', { bol: true, title: '正在恢复装置状态' })
      const rootInfo = await this.player.Native.ModelTree.getRootItems()
      if (rootInfo?.length && rootInfo[0].item) {
        await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
      }
      this.$emit('loadingSwitch', { bol: false, title: '正在恢复装置状态' })
    },
    // 当单个管线的按钮状态切换时，调整总体抽离开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = map(this.currentShowPipes, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.tagCode)) {
              hasNoAnimationPipe = true
              throw new Error()
            }
          })
          // eslint-disable-next-line no-empty
        } catch (e) {}
        if (hasNoAnimationPipe) {
          // 有未打开抽离的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未打开的抽离，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    moveToPipe(row) {
      if (row.tagCode) {
        this.player.Native.Camera.moveToCode(row.tagCode, 2)
      }
    },
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 5px !important;
  }
}
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
.pipe-extraction {
  ::v-deep .el-slider__bar {
    background: #11939d !important;
  }
  ::v-deep .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: 2px solid #11939d !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
